import clsx from 'clsx';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '@/components/typography';
import getDotColor from '@/features/comps/functions/getDotColor';
import { AcresFeature } from '@/models/features';
import { isCompFeature, isRealEstateFeature } from '@/models/features/guards';

type Props = {
  feature: AcresFeature;
  idx?: number;
};

export const CardDot: FC<Props> = ({ feature, idx = undefined }) => {
  if (isCompFeature(feature)) {
    const {
      properties: { visibility },
    } = feature;
    const dotColor = getDotColor(visibility);
    return (
      <div className={twMerge('m-auto mr-2 h-3 w-3 rounded-full', dotColor)} />
    );
  }

  if (isRealEstateFeature(feature)) {
    const { status } = feature.properties;
    return (
      <div
        className={clsx(
          'm-auto mr-3 flex h-3 w-3 items-center justify-center rounded-full',
          status === 'available' && 'bg-jade',
          status === 'sold' && 'bg-listings-sold',
          status === 'sale-pending' && 'bg-listings-sale-pending'
        )}
      />
    );
  }

  return (
    <div className="mr-2 h-5 w-5 rounded-full bg-green-50 text-white">
      <Typography className="text-center text-[14px] leading-5">
        {idx !== undefined ? idx + 1 : ''}
      </Typography>
    </div>
  );
};
